import React from 'react';
import {object, string, array} from "yup";
import {Box, Grid} from "@material-ui/core";

import {FormSubmitBtn, FormWrapper} from "../../../../dumb/FormHandlers";
import {MerchantInput} from "../../../../dumb/FormInputs";
import {default as DeleteIcon} from "@material-ui/icons/Delete";
import Button from "../../../../dumb/Button/C";
import {default as AddCircleOutlineIcon} from "@material-ui/icons/AddCircleOutline";

module.exports = ({appId, defaultData = {}, request, resultText}) => {

  const headerSchema = object({
    name: string()
      .test(
        'isUnique',
        'Must be unique',
        (val, ctx) => {
          const allHeaders = ((ctx.from[1] || {}).value || {}).headers || [];
          const numberOfValues = allHeaders.reduce((acc, el) => {
            if (el.name === val) acc = acc + 1;
            return acc;
          }, 0);
          return numberOfValues === 1;
        }
      )
      .matches(/^[a-zA-Z0-9\\-_]{1,256}$/)
      .required(),
    value: string().matches(/^[a-zA-Z0-9()\-=*.?;,+\/:&_ ]*$/).required()
  })

  const schema = object({
    name: string().mustBeHttps().isValidUrl().required(),
    callback_address: string().mustBeHttps().isValidUrl().required(),
    critical_callbacks_address: string().mustBeHttps().isValidUrl(),
    headers: array().of(headerSchema)
  });

  const onSubmit = ({headers, ...props}) => {
    const params = {
      ...props,
      critical_callbacks_enabled: !props.critical_callbacks_address,
      disabled_methods: [],
      headers: headers.length
        ? headers.map(({name, value}) => [name, value])
        : []
    }

    if (appId) params['app_id'] = appId;

    return request(params);
  }

  return (
    <FormWrapper
      data={{headers: [], ...defaultData}}
      schema={schema}
      onSubmit={onSubmit}
      resultModalData={resultText}
    >{(formCtx) => {

      const headers = formCtx.state.data.headers || [];
      const getHeadersErrors = (i, name) => formCtx.state.errors[`headers[${i}].${name}`];
      const click = formCtx.state.click;
      const onHeaderChange = (i) => (name, value) => {
        const prevValue = headers[i] || {};
        headers[i] = {...prevValue, [name]: value};
        formCtx.onChange('headers', headers);
      };
      const deleteHeader = (indexToDelete) => () => (
        formCtx.onChange(
          'headers',
          headers.filter((el, index) => index !== indexToDelete)
        )
      );
      const addHeader = () => (
        formCtx.onChange(
          'headers',
          [...headers, {}]
        )
      );

      return (
        <>
          <Box>
            <MerchantInput
              label="App URL (only https)"
              name="name"
              formCtx={formCtx}
            />
          </Box>
          <Box mt="30px">
            <MerchantInput
              label="Callback URL (only https)"
              name="callback_address"
              formCtx={formCtx}
            />
          </Box>
          <Box mt="30px">
            <MerchantInput
              label="Critical callback URL (only https)"
              name="critical_callbacks_address"
              formCtx={formCtx}
            />
          </Box>
          <Box mt="30px">
            <h2 className="f15 fw5">Headers</h2>
          </Box>
          {headers.map(({name, value}, i) => {
            const nameError = getHeadersErrors(i, 'name');
            const valError = getHeadersErrors(i, 'value');
            return (
              <Box key={i} mt="30px">
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid xs={4} item>
                    <MerchantInput
                      label="Name"
                      name="name"
                      value={name}
                      error={nameError}
                      showError={click && !!nameError}
                      onChange={onHeaderChange(i)}
                    />
                  </Grid>
                  <Grid xs={5} item>
                    <MerchantInput
                      label="Value"
                      name="value"
                      value={value}
                      error={valError}
                      showError={click && !!valError}
                      onChange={onHeaderChange(i)}
                    />
                  </Grid>
                  <Grid xs={3} item>
                    <Button onClick={deleteHeader(i)}>
                      <DeleteIcon/>
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )
          })}
          <Box mt="24px">
            <Button onClick={addHeader}>
              <AddCircleOutlineIcon/>
              <div className="pl10">Add</div>
            </Button>
          </Box>
          <Box mt="30px">
            <FormSubmitBtn formCtx={formCtx}>
              Save changes
            </FormSubmitBtn>
          </Box>
        </>
      )
    }}</FormWrapper>
  )
}
